import '../assets/scss/inputComponent.scss';

const InputComponent = ({
	label,
	type,
	name,
	className,
	placeholder,
	readOnly,
	required,
	register,
	onKeyDown,
	maxLength,
	...rest
}) => {
	const { onChange: restOnChange, ...restProps } = rest;
	const registration = register(name, {
		required: required ? 'Påkrevd felt' : false,
		maxLength: maxLength
			? { value: Number(maxLength), message: `Maks ${maxLength} tegn` }
			: undefined,
	});

	return (
		<div className={`input-container ${className}`}>
			<label htmlFor={name}>
				{label}
				{required && (
					<span style={{ color: 'red' }} className='required'>
						*
					</span>
				)}
			</label>
			<input
				type={type}
				name={name}
				id={name}
				placeholder={placeholder}
				readOnly={readOnly}
				required={required}
				maxLength={maxLength}
				onKeyDown={onKeyDown}
				{...registration}
				{...restProps}
				onChange={(event) => {
					registration.onChange(event);
					if (typeof restOnChange === 'function') {
						restOnChange(event);
					}
				}}
			/>
		</div>
	);
};

export default InputComponent;
